unit View.Cst_Cofins.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCst_CofinsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcst_cofins_id: TLabel;
    edcst_cofins_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCst_CofinsGet: TXDataWebClient;
    XDataClientCst_CofinsDelete: TXDataWebClient;
    Cst_CofinsDataset: TXDataWebDataSet;
    Cst_CofinsDatasetcst_cofins_id: TStringField;
    Cst_CofinsDatasetnome: TStringField;
    Cst_CofinsDatasetexcluido: TBooleanField;
    Cst_CofinsDatasetinclusao: TDateTimeField;
    Cst_CofinsDatasetalteracao: TDateTimeField;
    Cst_CofinsDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCst_CofinsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_CofinsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCst_CofinsDeleteError(Error: TXDataClientError);
    procedure Cst_CofinsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCst_CofinsEdit: TFViewCst_CofinsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCst_CofinsEdit }

procedure TFViewCst_CofinsEdit.btSaveClick(Sender: TObject);
begin
  if Cst_CofinsDataset.State in dsEditModes then
  begin
        Cst_CofinsDataset.Post;
    Cst_CofinsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCst_CofinsEdit.btDeleteClick(Sender: TObject);
begin
  if Cst_CofinsDataset.State in dsEditModes then
    Cst_CofinsDataset.Post;
  XDataClientCst_CofinsDelete.Delete(Cst_CofinsDataset.EntitySetName,
    TJSObject(Cst_CofinsDataset.CurrentData));
end;


class function TFViewCst_CofinsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCst_CofinsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCst_CofinsEdit.InsertEntity;
begin
  Cst_CofinsDataset.Close;
  Cst_CofinsDataset.SetJsonData('{}');
  Cst_CofinsDataset.Open;
  Cst_CofinsDataset.Insert;
end;

class function TFViewCst_CofinsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCst_CofinsEdit(AForm).FInserting := AInserting;
    TFViewCst_CofinsEdit(AForm).FId := AId;
    TFViewCst_CofinsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCst_CofinsEdit(AForm).InsertEntity
    else
      TFViewCst_CofinsEdit(AForm).LoadEntity;
    TFViewCst_CofinsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCst_CofinsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCst_CofinsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Cst_CofinsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Cst_CofinsDataset.EntitySetName
    )
  );
  XDataClientCst_CofinsGet.Get(Cst_CofinsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCst_CofinsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCst_CofinsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_CofinsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCst_CofinsEdit.XDataClientCst_CofinsGetLoad(Response: TXDataClientResponse);
begin
  Cst_CofinsDataset.Close;
  Cst_CofinsDataset.SetJsonData(Response.Result);
  Cst_CofinsDataset.Open;
  
  Cst_CofinsDataset.Edit;  
end;

procedure TFViewCst_CofinsEdit.XDataClientCst_CofinsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCst_CofinsEdit.XDataClientCst_CofinsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCst_CofinsEdit.Cst_CofinsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCst_CofinsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCst_CofinsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cst_cofins.form.message');
  lbMessage := TLabel.Create('view.cst_cofins.form.message.label');
  btCloseMessage := TButton.Create('view.cst_cofins.form.message.button');
  btCancel := TButton.Create('view.cst_cofins.form.btBack');
  btSave := TButton.Create('view.cst_cofins.form.btSave');
  btDelete := TButton.Create('view.cst_cofins.form.btDelete');
  lbcst_cofins_id := TLabel.Create('view.cst_cofins.form.lbcst_cofins_id');
  edcst_cofins_id := TDBEdit.Create('view.cst_cofins.form.edcst_cofins_id');
  lbnome := TLabel.Create('view.cst_cofins.form.lbnome');
  ednome := TDBEdit.Create('view.cst_cofins.form.ednome');
  lbexcluido := TLabel.Create('view.cst_cofins.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cst_cofins.form.edexcluido');
  lbinclusao := TLabel.Create('view.cst_cofins.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cst_cofins.form.edinclusao');
  lbalteracao := TLabel.Create('view.cst_cofins.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cst_cofins.form.edalteracao');
  lbexclusao := TLabel.Create('view.cst_cofins.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cst_cofins.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Cst_CofinsDataset := TXDataWebDataSet.Create(Self);
  Cst_CofinsDatasetcst_cofins_id := TStringField.Create(Self);
  Cst_CofinsDatasetnome := TStringField.Create(Self);
  Cst_CofinsDatasetexcluido := TBooleanField.Create(Self);
  Cst_CofinsDatasetinclusao := TDateTimeField.Create(Self);
  Cst_CofinsDatasetalteracao := TDateTimeField.Create(Self);
  Cst_CofinsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCst_CofinsGet := TXDataWebClient.Create(Self);
  XDataClientCst_CofinsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcst_cofins_id.BeforeLoadDFMValues;
  edcst_cofins_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Cst_CofinsDataset.BeforeLoadDFMValues;
  Cst_CofinsDatasetcst_cofins_id.BeforeLoadDFMValues;
  Cst_CofinsDatasetnome.BeforeLoadDFMValues;
  Cst_CofinsDatasetexcluido.BeforeLoadDFMValues;
  Cst_CofinsDatasetinclusao.BeforeLoadDFMValues;
  Cst_CofinsDatasetalteracao.BeforeLoadDFMValues;
  Cst_CofinsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCst_CofinsGet.BeforeLoadDFMValues;
  XDataClientCst_CofinsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCst_CofinsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcst_cofins_id.SetParentComponent(Self);
    lbcst_cofins_id.Name := 'lbcst_cofins_id';
    lbcst_cofins_id.Left := 24;
    lbcst_cofins_id.Top := 192;
    lbcst_cofins_id.Width := 14;
    lbcst_cofins_id.Height := 13;
    lbcst_cofins_id.Caption := 'cst_cofins_id:';
    lbcst_cofins_id.Transparent := True;
    edcst_cofins_id.SetParentComponent(Self);
    edcst_cofins_id.Name := 'edcst_cofins_id';
    edcst_cofins_id.Left := 221;
    edcst_cofins_id.Top := 189;
    edcst_cofins_id.Width := 200;
    edcst_cofins_id.Height := 21;
    edcst_cofins_id.Enabled := True;
    edcst_cofins_id.TabOrder := 6;
    edcst_cofins_id.Text := 'edcst_cofins_id';
    edcst_cofins_id.DataField := 'cst_cofins_id';
    edcst_cofins_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Cst_CofinsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Cst_CofinsDataset.SetParentComponent(Self);
    Cst_CofinsDataset.Name := 'Cst_CofinsDataset';
    Cst_CofinsDataset.AfterApplyUpdates := Cst_CofinsDatasetAfterApplyUpdates;
    Cst_CofinsDataset.EntitySetName := 'Cst_Cofins';
    Cst_CofinsDataset.Connection := DMConnection.ApiConnection;
    Cst_CofinsDataset.Left := 176;
    Cst_CofinsDataset.Top := 8;
    Cst_CofinsDatasetcst_cofins_id.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetcst_cofins_id.Name := 'Cst_CofinsDatasetcst_cofins_id';
    Cst_CofinsDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Cst_CofinsDatasetcst_cofins_id.Required := True;
    Cst_CofinsDatasetcst_cofins_id.Size := 255;
    Cst_CofinsDatasetnome.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetnome.Name := 'Cst_CofinsDatasetnome';
    Cst_CofinsDatasetnome.FieldName := 'nome';
    Cst_CofinsDatasetnome.Required := True;
    Cst_CofinsDatasetnome.Size := 255;
    Cst_CofinsDatasetexcluido.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetexcluido.Name := 'Cst_CofinsDatasetexcluido';
    Cst_CofinsDatasetexcluido.FieldName := 'excluido';
    Cst_CofinsDatasetexcluido.Required := False;
    Cst_CofinsDatasetinclusao.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetinclusao.Name := 'Cst_CofinsDatasetinclusao';
    Cst_CofinsDatasetinclusao.FieldName := 'inclusao';
    Cst_CofinsDatasetinclusao.Required := False;
    Cst_CofinsDatasetalteracao.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetalteracao.Name := 'Cst_CofinsDatasetalteracao';
    Cst_CofinsDatasetalteracao.FieldName := 'alteracao';
    Cst_CofinsDatasetalteracao.Required := False;
    Cst_CofinsDatasetexclusao.SetParentComponent(Cst_CofinsDataset);
    Cst_CofinsDatasetexclusao.Name := 'Cst_CofinsDatasetexclusao';
    Cst_CofinsDatasetexclusao.FieldName := 'exclusao';
    Cst_CofinsDatasetexclusao.Required := False;
    XDataClientCst_CofinsGet.SetParentComponent(Self);
    XDataClientCst_CofinsGet.Name := 'XDataClientCst_CofinsGet';
    XDataClientCst_CofinsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_CofinsGet, Self, 'OnLoad', 'XDataClientCst_CofinsGetLoad');
    XDataClientCst_CofinsGet.Left := 64;
    XDataClientCst_CofinsGet.Top := 8;
    XDataClientCst_CofinsDelete.SetParentComponent(Self);
    XDataClientCst_CofinsDelete.Name := 'XDataClientCst_CofinsDelete';
    XDataClientCst_CofinsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCst_CofinsDelete, Self, 'OnLoad', 'XDataClientCst_CofinsDeleteLoad');
    SetEvent(XDataClientCst_CofinsDelete, Self, 'OnError', 'XDataClientCst_CofinsDeleteError');
    XDataClientCst_CofinsDelete.Left := 64;
    XDataClientCst_CofinsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcst_cofins_id.AfterLoadDFMValues;
    edcst_cofins_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Cst_CofinsDataset.AfterLoadDFMValues;
    Cst_CofinsDatasetcst_cofins_id.AfterLoadDFMValues;
    Cst_CofinsDatasetnome.AfterLoadDFMValues;
    Cst_CofinsDatasetexcluido.AfterLoadDFMValues;
    Cst_CofinsDatasetinclusao.AfterLoadDFMValues;
    Cst_CofinsDatasetalteracao.AfterLoadDFMValues;
    Cst_CofinsDatasetexclusao.AfterLoadDFMValues;
    XDataClientCst_CofinsGet.AfterLoadDFMValues;
    XDataClientCst_CofinsDelete.AfterLoadDFMValues;
  end;
end;

end.
